export default (context) => {
    if(context.$route.query.order) {
        context.get_order_state(context)
    } else {
        context.get_users_orders(context)
    }

    let timeout = setTimeout(() => {
        if(context.clearTimeout) {
            clearTimeout(timeout)
        } else {
            context.check_order(context)
        }
    }, 5000)
}